export const DONATE_ADDRESS = "iota1qrss8vtul7jsp0qx2ds7t0xyvrqyt4fan3zraaeuwrqjv4h08522vdcd33j";
export const ROADMAP_URL = "https://trello.com/b/WkdXgRKw";
export const ISSUES_URL = "https://github.com/iotapoker/issues/issues";
